import { render, staticRenderFns } from "./SwiperCarrouselSlide.vue?vue&type=template&id=d3745e26&"
import script from "./SwiperCarrouselSlide.vue?vue&type=script&lang=js&"
export * from "./SwiperCarrouselSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ResponsivePicture: require('/codebuild/output/src1887633789/src/kokalanov/components/global/ResponsivePicture.vue').default})
